// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_card {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  width: 100vw;
  height: 100vh;
}

.p__card {
  background-color: white;
  width: 90%;
  max-width: 900px;
  margin: 0px auto;
  padding: 80px 30px 25px 30px;
  float: none;
  /* margin-top: 80px; */
  border-radius: 5px;
  box-sizing: border-box;
  /* padding: 80px 30px 25px 30px; */
  text-align: center;
  position: relative;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}

.card__success {
  position: absolute;
  top: -8%;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 100px;
  border-radius: 100%;
  background-color: #210062;
  border: 5px solid white;
}

.card__msg {
  /* text-transform: uppercase; */
  color: #55585b;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 5px;
}

.card__submsg {
  color: #55585b;
  font-size: 18px;
  font-weight: 800;
  margin-top: 0px;
}

.card__body {
  background-color: #210062;
  border-radius: 4px;
  width: 100%;
  float: left;
  padding: 5px;
  color: #eee;
  box-sizing: border-box;
}

.card__recipient-info {
  display: flex;
  justify-content: space-evenly;
  margin-top: 0.8rem;
}

.card__recipient {
  color: white;
  font-weight: 600;
}

.card__price {
  color: white;
  font-size: 70px;
}

.card__price span {
  font-size: 60%;
}

.card__details {
  padding: 0 1rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 0.5rem;
}
.card__details__inner {
  width: 100%;
}

.card__details ul {
  list-style: none;
  width: 80%;
  /* margin: 0 auto; */
  display: flex;
  flex-direction: row;
}

.card__details ul li {
  /* text-align: center; */
  font-size: 1rem;
  padding: 0.5rem;
}

.card__details ul li:not(:last-child) {
  border-bottom: 1px solid #eee;
}

@media screen and (max-width: 935px) {
  .card__details {
    flex-direction: column;
    margin-bottom: 5px;
  }

  .card__success {
    position: absolute;
    top: -8%;
  }
}

@media screen and (max-width: 600px) {
  .card__msg {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .card__submsg {
    font-size: 14px;
  }

  .card__success {
    position: absolute;
    top: -6%;
  }

  .card__details {
    flex-direction: column;
    margin-bottom: 5px;
  }
  .card__details ul li {
    font-size: 14px;
    padding: 0.5rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component new/PaymentSuccess/PaymentSuccess.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".main_card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  width: 100vw;\n  height: 100vh;\n}\n\n.p__card {\n  background-color: white;\n  width: 90%;\n  max-width: 900px;\n  margin: 0px auto;\n  padding: 80px 30px 25px 30px;\n  float: none;\n  /* margin-top: 80px; */\n  border-radius: 5px;\n  box-sizing: border-box;\n  /* padding: 80px 30px 25px 30px; */\n  text-align: center;\n  position: relative;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n}\n\n.card__success {\n  position: absolute;\n  top: -8%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100px;\n  height: 100px;\n  border-radius: 100%;\n  background-color: #210062;\n  border: 5px solid white;\n}\n\n.card__msg {\n  /* text-transform: uppercase; */\n  color: #55585b;\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 5px;\n}\n\n.card__submsg {\n  color: #55585b;\n  font-size: 18px;\n  font-weight: 800;\n  margin-top: 0px;\n}\n\n.card__body {\n  background-color: #210062;\n  border-radius: 4px;\n  width: 100%;\n  float: left;\n  padding: 5px;\n  color: #eee;\n  box-sizing: border-box;\n}\n\n.card__recipient-info {\n  display: flex;\n  justify-content: space-evenly;\n  margin-top: 0.8rem;\n}\n\n.card__recipient {\n  color: white;\n  font-weight: 600;\n}\n\n.card__price {\n  color: white;\n  font-size: 70px;\n}\n\n.card__price span {\n  font-size: 60%;\n}\n\n.card__details {\n  padding: 0 1rem 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n  margin-top: 0.5rem;\n}\n.card__details__inner {\n  width: 100%;\n}\n\n.card__details ul {\n  list-style: none;\n  width: 80%;\n  /* margin: 0 auto; */\n  display: flex;\n  flex-direction: row;\n}\n\n.card__details ul li {\n  /* text-align: center; */\n  font-size: 1rem;\n  padding: 0.5rem;\n}\n\n.card__details ul li:not(:last-child) {\n  border-bottom: 1px solid #eee;\n}\n\n@media screen and (max-width: 935px) {\n  .card__details {\n    flex-direction: column;\n    margin-bottom: 5px;\n  }\n\n  .card__success {\n    position: absolute;\n    top: -8%;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .card__msg {\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n\n  .card__submsg {\n    font-size: 14px;\n  }\n\n  .card__success {\n    position: absolute;\n    top: -6%;\n  }\n\n  .card__details {\n    flex-direction: column;\n    margin-bottom: 5px;\n  }\n  .card__details ul li {\n    font-size: 14px;\n    padding: 0.5rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
